<template>
  <div id="survey-table">
    <b-table head-variant="light"
             v-if="showTable"
             bordered
             :items="items"
             :fields="fields">
      <template #custom-foot
                v-if="showFooter">
        <b-tr>
          <template v-for="field in fields">
            <b-td v-if="field.key === '빈도'"
                  class="text-center align-middle"
                  :key="field.key">
              {{ items.reduce((sum, d) => sum + d["빈도"], 0) }}
            </b-td>
            <b-td v-else-if="field.key === '비율'"
                  class="text-center align-middle"
                  :key="field.key">
              100%
            </b-td>
            <b-td v-else
                  class="text-center"
                  :key="field.key">
              {{ "총합" }}
            </b-td>
          </template>
        </b-tr>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  props: {
    slide: Object,
    items: Array,
    graphType: String
  },
  computed: {
    showTable() {
      return this.items.length > 0;
    },
    fields() {
      let item = this.items[0];
      let fields = [];

      for (let property in item) {
        fields.push({
          key: property,
          thClass: ["text-center"],
          class: ["text-center", "align-middle"],
          formatter: property === '비율' ? this.formatter : null
        });
      }
      return fields;
    },
    showFooter() {
      return this.fields.some(field => field.key === '비율' || field.key === '빈도');
    },
  },
  methods: {},
  data() {
    return {
      formatter: str => str + "%"
    };
  }
};
</script>

<style>
#survey-table table{
    max-height: 400px;
    font-size: 13pt;
    margin-bottom: 0;
    margin-top: 10px;
}

#survey-table tfoot tr {
    color: #495057;
    background-color: #e9ecef;
    border-color: #dee2e6;
}

#survey-table tfoot tr :first-child {
    font-weight: bold;
}
</style>
